// Centralized site content for Sean Bledsoe executive site
export const SITE = {
  name: "Sean Bledsoe",
  role: "CEO & Founder · Healthcare Innovator · Coach",
  shortBio:
    "CEO and President of Healthy Plus, founder of DigiDoc, and the youngest head college basketball coach in NCAA history at age 24 — re-shaping the culture of prevention through an e-health platform built for patients, doctors, and payers.",
  email: "sbledsoe1109@gmail.com",
  location: "United States · India",
  socials: {
    linkedin: "https://www.linkedin.com/in/sean-bledsoe",
    digidoc: "#digidoc",
    healthyplus: "https://healthyplus.com",
  },
};

export const STATS = [
  { label: "Medical Data Points", value: "400", suffix: "+" },
  { label: "Reduction in MD Workload", value: "15", suffix: "%" },
  { label: "Healthcare Lenses", value: "3", suffix: "" },
  { label: "Years Building", value: "20", suffix: "+" },
];

export const VENTURES = [
  {
    name: "Healthy Plus",
    role: "CEO & President",
    sector: "Preventive Care · Wellness Screening",
    summary:
      "The \"GAP\" company aligning doctors, patients, and insurance carriers. Up to 400 medical data points captured per patient, reducing physician wellness workload by 15%.",
    accent: "01",
  },
  {
    name: "DigiDoc",
    role: "Founder",
    sector: "Digital Health Ecosystem",
    summary:
      "An AI-driven risk stratification and care-management platform built on the Healthy Plus + Healthy Plus India backbone — fully integrated with athenahealth provider networks.",
    accent: "02",
  },
  {
    name: "Bledsoe Basketball Academy (BBA)",
    role: "Founder",
    sector: "Athlete Development",
    summary:
      "Player-development program founded from two decades of college coaching experience — bridging elite skill training with academic and life-skill mentorship.",
    accent: "03",
  },
  {
    name: "Healthy Plus India Pvt. Ltd.",
    role: "Founder · Parent of DigiDoc India",
    sector: "Global Healthcare",
    summary:
      "Indian subsidiary operationalizing DigiDoc across the subcontinent — 100% DPDP-compliant, fully paperless, hospital and provider partnerships in progress.",
    accent: "04",
  },
];

export const EXPERTISE = [
  {
    title: "Preventive Care Architecture",
    body:
      "Built the Healthy Plus risk-prediction engine on CMS preventive guidelines — pairing nurse-level Health Coaches with an algorithmic 400-data-point assessment.",
  },
  {
    title: "Digital Health Innovation",
    body:
      "DigiDoc's hybrid model marries digital tooling with human touch — AI-based risk stratification, virtual care management, paperless transactions, and a global Health Locker.",
  },
  {
    title: "Global Partnerships",
    body:
      "Founded Healthy Plus India Pvt. Ltd., integrated with athenahealth's provider network, and is actively building hospital partnerships across the U.S. and India.",
  },
  {
    title: "Coaching Leadership",
    body:
      "Youngest NCAA head college basketball coach at 24. Assistant coaching tenures at Urbana University, Indiana State, Bowling Green, Cleveland State, and UMKC.",
  },
];

export const PROJECTS = [
  {
    title: "athenahealth Network Integration",
    region: "United States · 2017",
    impact: "Healthy Plus app live across athenahealth's provider network",
    color: "from-[#0A192F] to-[#1E3A8A]",
  },
  {
    title: "DigiDoc Health Locker",
    region: "U.S. · India",
    impact: "Globally accessible medical history, 100% DPDP-secure",
    color: "from-[#0A192F] to-[#334155]",
  },
  {
    title: "Corporate Wellness Program",
    region: "U.S. Employers",
    impact: "Nurse-level coaches + risk reports routed to in-network MDs",
    color: "from-[#0B1D3A] to-[#475569]",
  },
  {
    title: "Virtual Care Management",
    region: "Global",
    impact: "Specialized doctors, paperless workflow, diet & exercise regimes",
    color: "from-[#0A192F] to-[#1E293B]",
  },
];

export const SPEAKING = [
  { event: "Industry Tech Outlook", topic: "Top 10 Entrepreneurs to Watch", year: "2020" },
  { event: "Shortlister Top Vendor Recognition", topic: "Health Risk Assessment Category", year: "2020" },
  { event: "athenahealth Marketplace Launch", topic: "Integrated Wellness for Providers", year: "2017" },
  { event: "LinkedIn Feature", topic: "Women's Digital Health Empowerment (contributor)", year: "2024" },
  { event: "NCAA Coaching Clinics", topic: "Leadership Lessons from the Sideline", year: "Recurring" },
  { event: "Healthy Plus Provider Roundtables", topic: "Reshaping the Culture of Prevention", year: "Ongoing" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Sean built the only system I've seen that actually aligns the doctor, the patient, and the insurance carrier on the same incentive — prevention.",
    name: "Provider Network Director",
    title: "athenahealth Marketplace Partner",
  },
  {
    quote:
      "DigiDoc's hybrid of digital tooling with a real human Health Coach is the model. It's what the industry has been chasing for a decade.",
    name: "Corporate Wellness Director",
    title: "Fortune 1000 Employer",
  },
  {
    quote:
      "From the sideline to the boardroom, Sean leads the same way — composed, prepared, and ten moves ahead. That's why our players still call him coach.",
    name: "Former NCAA Athletic Director",
    title: "Division I Program",
  },
];

export const PARTNERS = [
  "athenahealth",
  "Healthy Plus",
  "Healthy Plus India",
  "DigiDoc",
  "Shortlister · Top Vendor 2020",
  "Industry Tech Outlook · Top 10",
  "CMS Preventive Guidelines",
  "Urbana University",
  "Indiana State",
  "Bowling Green",
  "Cleveland State",
  "UMKC",
];

export const AWARDS = [
  {
    year: "2020",
    title: "Top 10 Entrepreneurs to Watch",
    org: "Industry Tech Outlook",
  },
  {
    year: "2020 · Q4",
    title: "Top Vendor — Health Risk Assessment",
    org: "Shortlister",
  },
  {
    year: "2017",
    title: "athenahealth Marketplace Launch",
    org: "PR Newswire feature",
  },
  {
    year: "Career",
    title: "Youngest NCAA Head College Coach (Age 24)",
    org: "Bledsoe Coaching Legacy",
  },
];
